import './App.css';
import Created from './router/created';

function App() {
  return (
    <div className="App">
      <Created/>
    </div>
  );
}

export default App;
